'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleDisabledText = exports.simpleNonRequiredText = exports.simpleRequiredText = undefined;
var _wavfichacertaFichacertaUtils = require('@bit/wavfichacerta.fichacerta.utils.validators');
var sizes = {
  generalMedium: 'col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6'
};
var simpleRequiredText = exports.simpleRequiredText = function simpleRequiredText(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === undefined ? sizes.generalMedium : _ref$size,
    name = _ref.name,
    label = _ref.label,
    _ref$validate = _ref.validate,
    validate = _ref$validate === undefined ? _wavfichacertaFichacertaUtils.emptyValidation : _ref$validate,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === undefined ? '' : _ref$placeholder;
  return {
    name: name,
    label: label,
    isRequired: true,
    size: size,
    type: 'text',
    placeholder: placeholder,
    validate: validate
  };
};
var simpleNonRequiredText = exports.simpleNonRequiredText = function simpleNonRequiredText(_ref2) {
  var _ref2$size = _ref2.size,
    size = _ref2$size === undefined ? sizes.generalMedium : _ref2$size,
    name = _ref2.name,
    label = _ref2.label,
    _ref2$format = _ref2.format,
    format = _ref2$format === undefined ? null : _ref2$format,
    _ref2$warn = _ref2.warn,
    warn = _ref2$warn === undefined ? null : _ref2$warn,
    _ref2$normalize = _ref2.normalize,
    normalize = _ref2$normalize === undefined ? null : _ref2$normalize,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === undefined ? '' : _ref2$placeholder,
    permission = _ref2.permission;
  return {
    name: name,
    label: label,
    isRequired: false,
    size: size,
    type: 'text',
    value: "",
    warn: warn,
    normalize: normalize,
    format: format,
    placeholder: placeholder,
    permission: permission
  };
};
var simpleDisabledText = exports.simpleDisabledText = function simpleDisabledText(_ref3) {
  var _ref3$size = _ref3.size,
    size = _ref3$size === undefined ? sizes.generalMedium : _ref3$size,
    name = _ref3.name,
    label = _ref3.label,
    _ref3$placeholder = _ref3.placeholder,
    placeholder = _ref3$placeholder === undefined ? '' : _ref3$placeholder;
  return {
    name: name,
    label: label,
    disabled: true,
    size: size,
    type: 'textDisabled',
    placeholder: placeholder
  };
};